module.exports = __webpack_public_path__ + "static/bg-happy_hockey-mobile-4fc025b48fed896fee8b0d82412211b9.jpg";